module.exports = __webpack_public_path__ + "img/honor02.108a26a2.webp";